import React from "react";

const nullFilter = (row, columnId, filterValue) => {
    const cellValue = row.getValue(columnId);

    if (filterValue.toLowerCase() === "null" || filterValue.toLowerCase() === "empty") {
      return cellValue === null || cellValue === undefined || cellValue === "";
    }

    return String(cellValue).toLowerCase().includes(filterValue.toLowerCase());
};



export function BaseColumns (data) {
    if (!data || data.length === 0) return []; // Ensure data exists before trying to access it
    const v_allocationBoard = data[0]?.c001_allocationboard;
    const baseColumns =  [
      {
        header: "Institute",
        footer: "Institute",
        accessorFn: (row) => `(${row.c001_instcode}) ${row.c001_instname}`,
        minSize: 600,
      },
      {
        accessorFn: (row) => row.c001_branchcode ? `(${row.c001_branchcode}) ${row.c001_branchname}`: row.c001_branchname,
        header: "Branch",
        footer: "Branch",
        minSize: 400,
      },
      {
        accessorKey: "c001_statequota",
        header: "State Quota",
        footer: "State Quota",
        enableColumnFilter: false, // disable column filtering for this column
      },
      {
        accessorKey: "c001_clrank",
        header: "Closing Rank",
        footer: "Closing Rank",
      },
    ];
    if (v_allocationBoard == ('COMEDK')) {
      baseColumns.splice(3,0, {
            accessorFn: (row) => (row.c001_category !== null ? `${row.c001_category}` : ""),
            accessorKey: "c001_category",
            header: "Category",
            footer: "Category",
          },
      );
    }
    else {
      baseColumns.splice(5,0, {
            accessorKey: "c001_common",
            header: "Common",
            footer: "Common",
            filterFn: nullFilter, // Apply the custom nullFilter to enable user to search by null or empty values
      },);
    }

    if (v_allocationBoard === "MHTCET-MH") {
      baseColumns.splice(3,0, {
        accessorFn: (row) => (row.c001_stage !== null ? `${row.c001_stage}` : ""),
        header: "Stage",
        footer: "Stage",
      },);
    } else if (v_allocationBoard === "MHTCET-AI") {
        baseColumns.splice(3,0, {
            accessorFn: (row) => (row.c001_summary !== null ? `${row.c001_summary}` : ""),
            header: "Summary",
            footer: "Summary",
            filterFn: nullFilter, // Apply the custom filter to enable use to search for empty data
          },);
    }
    if (v_allocationBoard.includes('MHTCET')) {
      baseColumns.push(
          {
            accessorFn: (row) => (row.c001_clptile !== null ? `${row.c001_clptile}` : ""),
            accessorKey: "c001_clptile",
            header: "Closing Percentile",
            footer: "Closing Percentile",
          },
      );
    }
    
    return baseColumns;
  }